import { Layout } from "antd";
import { ToggleableProps } from "../common/Toggleable";
import { Content } from "antd/es/layout/layout";
import { Page } from "../common/Page";
import { Modal } from "../common/Modal";

export const DomainPageLayout = function (props: {
    list: any,
    detailForm: any,
    detailToggle: ToggleableProps,
    onDetailCancel?: () => void,
}) {

    return (
        <Page name="Domains">
            <Layout style={{ height: "100%" }} >
                <Content style={{overflowY: "auto" }}>
                    {props.list}
                </Content>
            </Layout>

            <Modal title="Editando dominio" mode="FullPage"
                toggle={props.detailToggle} onCancel={props.onDetailCancel}
            >
                {props.detailForm}
            </Modal>

        </Page>
    );

}
